import { SVGProps } from "react";

export const WarningIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.8716 3.50974C12.6945 3.19486 12.3613 3 12 3C11.6387 3 11.3055 3.19486 11.1284 3.50974L2.12842 19.5097C1.95425 19.8194 1.95744 20.1982 2.13679 20.5048C2.31614 20.8115 2.64474 21 3 21H21C21.3553 21 21.6839 20.8115 21.8632 20.5048C22.0426 20.1982 22.0457 19.8194 21.8716 19.5097L12.8716 3.50974ZM12 15C11.4477 15 11 14.5523 11 14V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V14C13 14.5523 12.5523 15 12 15ZM11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17Z"
                fill="#FC6538"
            />
        </svg>
    );
};
